import { useMemo } from "react";
import { FCX, RecentSearches as PlatformRecentSearches } from "@datassential/platform-ui-lib";
import cn from "classnames";
import useRecentSearches from "@apiHooks/useRecentSearches";
import { excludeNullable, mapByKey } from "@core/utils/array";

interface RecentSearchesProps {
    onSearchClick: (search: string) => void;
}

const RecentSearches: FCX<RecentSearchesProps> = ({ className, onSearchClick }) => {
    const { isLoading, data } = useRecentSearches();

    const recentSearches = useMemo(() => excludeNullable(mapByKey(data, 'text')), [data]);

    if (isLoading || !recentSearches.length) return null;

    return (
        <PlatformRecentSearches
            className={cn(
                "ToolSearch__recent-searches",
                "ToolSearchRecentSearches",
                "appears-top",
                "fast",
                className
            )}
            title="Recent Searches"
            searches={recentSearches}
            onSearchClick={onSearchClick}
        />
    );
};

export default RecentSearches;